(() => {
  const SAMPLE_TAG = "sample"; // must match your product tag
  const STORAGE_KEY = "sample_variant_ids";

  // Save sample variant IDs when a sample gets added
  function rememberSampleVariantId(variantId) {
    try {
      const existing = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      if (!existing.includes(variantId)) existing.push(variantId);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
    } catch (e) {}
  }

  // Fetch cart
  async function getCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    return res.json();
  }

  // Update cart quantities in one call
  async function updateCart(updates) {
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ updates })
    });
  }

  // Determine if cart has any NON-sample items
  function hasNonSampleItems(cart) {
    return cart.items.some(item => {
      // Shopify exposes product tags in /cart.js as `product_has_only_default_variant` etc,
      // but NOT reliably tags. So we use a fallback: store sample variant ids locally,
      // plus a safe heuristic: if item title contains "Sample" (optional).
      // Best: store variant IDs when adding samples.
      return !isSampleItem(item);
    });
  }

  function isSampleItem(item) {
    // 1) check localStorage remembered sample variant ids
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      if (saved.includes(item.variant_id)) return true;
    } catch (e) {}

    // 2) handle-based check — locale-proof (titlurile se traduc pe /en /bg /hu,
    //    handle-ul nu). Aceeași logică + excepții ca isMostreHandle din nara-custom.js.
    const h = (item.handle || "").toLowerCase();
    if (h.startsWith("mostra") || h.startsWith("mostre") || h.includes("sample") || h === "petiteknit-double-sunday-1") return true;

    // 3) fallback heuristic pe titlu (doar pt. iteme fără handle în /cart.js)
    const t = (item.product_title || item.title || "").toLowerCase();
    if (t.includes("sample") || t.includes("mostra") || t.includes("eșantion") || t.includes("esantion")) {
      return true;
    }

    return false;
  }

  async function removeAllSamplesIfNoPaidItems() {
    const cart = await getCart();

    // If cart is empty, nothing to do
    if (!cart.items || cart.items.length === 0) return;

    // If there are paid/non-sample items, keep samples
    if (hasNonSampleItems(cart)) return;

    // Cart contains only samples -> remove them
    const updates = {};
    cart.items.forEach(item => {
      if (isSampleItem(item)) updates[item.variant_id] = 0;
    });

    if (Object.keys(updates).length) {
      await updateCart(updates);
      // If your theme uses sections rendering, it will likely re-render automatically.
      // Otherwise, force refresh:
      window.location.reload();
    }
  }

  // Track sample adds: hook into add-to-cart forms
  document.addEventListener("submit", (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.action || !form.action.includes("/cart/add")) return;

    const fd = new FormData(form);
    const id = fd.get("id");
    if (!id) return;

    // Only remember if this product is a sample:
    // simplest: your sample products have tag "sample" AND you add a hidden input.
    // If you can add a hidden input in Liquid, do that (below).
    const isSample = fd.get("properties[_sample]") === "true";
    if (isSample) rememberSampleVariantId(Number(id));
  });

  // Run after any cart change (best effort):
  // 1) on page load
  // 2) on custom theme events (common)
  // 3) after click in cart/drawer
  window.addEventListener("load", () => removeAllSamplesIfNoPaidItems());

  document.addEventListener("click", (e) => {
    const el = e.target;
    if (!(el instanceof Element)) return;
    // If user clicks remove/minus in cart, check shortly after
    if (el.closest("[data-cart-remove], .cart-remove, button[name='minus'], a[href*='quantity=0']")) {
      setTimeout(() => removeAllSamplesIfNoPaidItems(), 600);
    }
  });

  // Many Shopify themes dispatch this
  document.addEventListener("cart:updated", () => removeAllSamplesIfNoPaidItems());
})();